import type {
  InvoiceEmailSuggestion,
  InvoiceEmailSuggestionParams,
} from './types';

import { ENDPOINT } from '~/constants/endpoints';

import type { KyRequestOptions } from '@vestigas/data';

import { vestigasApi } from '~/services/kyClient';

import {
  zodInvoiceEmailSuggestionEndpointSchema,
  zodInvoiceEmailSuggestionResponseSchema,
} from './validations';

/**
 * Fetches the suggested recipient, content, and attachable files for an
 * invoice-issuer email.
 *
 * @param params - Invoice identifier and email kind to suggest.
 * @param options - Request options, including cancellation.
 * @returns The email suggestion.
 * @see https://app.dev.vestigas.com/redoc
 */
export const fetchInvoiceEmailSuggestion = async (
  { invoiceId, kind }: InvoiceEmailSuggestionParams,
  options?: KyRequestOptions,
): Promise<InvoiceEmailSuggestion> => {
  const response = await vestigasApi
    .get(ENDPOINT.INVOICE.GET_EMAIL_SUGGESTION(invoiceId, kind), {
      ...options,
      validate: {
        ...options?.validate,
        pathSegments: zodInvoiceEmailSuggestionEndpointSchema,
        response: zodInvoiceEmailSuggestionResponseSchema,
      },
    })
    .json<unknown>();

  return zodInvoiceEmailSuggestionResponseSchema.parse(response);
};
